import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <div className="pt-20 bg-white">
        {/* Header */}
        <section className="bg-gradient-to-br from-[#e9f2fc] to-[#d0e7f9] py-20 px-6 md:px-16 sm:px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-4xl sm:text-3xl font-bold text-gray-800 mb-6">
              {t("contact.heading")}
            </h1>
            <p className="text-xl md:text-lg text-gray-700">
              {t("contact.description")}
            </p>
          </div>
        </section>

        {/* Contact Content */}
        <section className="py-16 px-6 md:px-16 sm:px-4">
          <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-1 gap-12">
            {/* Contact Info */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-6">
                  Get In Touch
                </h2>
                <p className="text-gray-600 mb-8">
                  {t("contact.description")}
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-blueLight w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-textBlue" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">
                      {t("contact.address")}
                    </h3>
                    <p className="text-gray-600">{t("contact.addressText")}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-blueLight w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-textBlue" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">
                      {t("contact.phone")}
                    </h3>
                    <p className="text-gray-600">{t("contact.phoneText")}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-blueLight w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-textBlue" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">
                      {t("contact.email")}
                    </h3>
                    <p className="text-gray-600">{t("contact.emailText")}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-blueLight w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-textBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">Website</h3>
                    <a href={`https://${t("contact.website")}`} target="_blank" rel="noopener noreferrer" className="text-textBlue hover:underline">
                      {t("contact.website")}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Image */}
            <div className="flex items-center justify-center">
              <img
                src="/img_contactpage.svg"
                alt="Contact Us"
                className="w-full h-auto rounded-xl"
              />
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}
